module.exports = __webpack_public_path__ + "img/Military-baner.a3d19143.webp";